// pp-calc-margen.js — ¿Cuánto Ganas Revendiendo Empaque?
// (/pages/calculadora-de-margen-para-distribuidores)
//
// La calculadora del distribuidor: compra empaque por mayoreo, lo revende en
// su ciudad, y quiere saber si el negocio da. Toda la aritmética es sobre el
// precio de VENTA como base (margen, no markup):
//
//   margen bruto %   = (venta − costo) ÷ venta
//   ganancia bruta   = (venta − costo) × piezas al mes
//   gastos del mes   = venta × piezas × % de gastos del negocio
//   ganancia neta    = bruta − gastos
//   margen neto %    = neta ÷ (venta × piezas)
//   inversión al mes = costo × piezas
//   ROI mensual %    = neta ÷ inversión
//
// Regla de honestidad: vender a pérdida o en tablas (venta ≤ costo) NO es un
// error de captura — es un resultado, y se contesta con veredicto rojo, no
// con null. Null se reserva para datos faltantes o inválidos.
//
// Aritmética pura probada en tests/calc-margen.test.mjs.
(function (root) {
  'use strict';

  // Umbrales del semáforo sobre el margen NETO (%): en reventa de empaque un
  // margen neto sano anda arriba del 20% — abajo del 8% no paga el esfuerzo.
  var UMBRAL_VERDE = 20;
  var UMBRAL_AMARILLO = 8;

  // Entradas: costoPieza ($ que paga el distribuidor por pieza al mayoreo),
  // ventaPieza ($ al que revende la pieza), piezasMes (unidades estimadas al
  // mes), gastosPct (gastos del negocio como FRACCIÓN de las ventas: 0.05,
  // 0.15 o el % capturado a mano ÷ 100).
  function calcularMargen(e) {
    if (!e) return null;
    var costo = num(e.costoPieza), venta = num(e.ventaPieza),
        piezas = num(e.piezasMes), pct = num(e.gastosPct);
    if ([costo, venta, piezas].some(function (v) { return v === null || v <= 0; })) return null;
    if (pct === null || pct < 0) return null;

    var ventasMes = venta * piezas;
    var gananciaBrutaMes = (venta - costo) * piezas;
    var gastosMes = ventasMes * pct;
    var gananciaNetaMes = gananciaBrutaMes - gastosMes;
    var inversionMes = costo * piezas;

    var r = {
      margenBrutoPct: ((venta - costo) / venta) * 100,
      gananciaBrutaMes: gananciaBrutaMes,
      gastosMes: gastosMes,
      gananciaNetaMes: gananciaNetaMes,
      margenNetoPct: (gananciaNetaMes / ventasMes) * 100,
      inversionMes: inversionMes,
      roiMensualPct: (gananciaNetaMes / inversionMes) * 100,
      ventaAPerdida: venta <= costo
    };

    if (r.ventaAPerdida) r.veredicto = 'rojo';
    else if (r.margenNetoPct >= UMBRAL_VERDE) r.veredicto = 'verde';
    else if (r.margenNetoPct >= UMBRAL_AMARILLO) r.veredicto = 'amarillo';
    else r.veredicto = 'rojo';

    return r;
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPMargen = {
    UMBRAL_VERDE: UMBRAL_VERDE,
    UMBRAL_AMARILLO: UMBRAL_AMARILLO,
    calcularMargen: calcularMargen
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-margen]');
    if (!raiz) return;
    var C = window.PPMargen;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');
    var selGastos = $('select[name="gastos"]');
    var campoCustom = $('[data-gastos-custom]');

    // El campo "Captura mi %" vive oculto con la clase .hidden de base.css —
    // el atributo [hidden] pierde contra el display de pp-calc.css.
    function toggleCustom() {
      if (campoCustom && selGastos) campoCustom.classList.toggle('hidden', selGastos.value !== 'custom');
    }
    if (selGastos) selGastos.addEventListener('change', toggleCustom);
    toggleCustom();

    function fmtDinero(n) {
      return '$' + n.toLocaleString('es-MX', { maximumFractionDigits: 0 });
    }
    function fmtPct(n) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: 1 }) + '%';
    }

    function pctDeGastos(f) {
      var v = f.get('gastos');
      if (v === 'custom') {
        var p = Number(String(f.get('gastos_pct') || '').replace(',', '.'));
        return isFinite(p) && String(f.get('gastos_pct') || '') !== '' ? p / 100 : null;
      }
      return Number(v);
    }

    function correr() {
      var f = new FormData(form);
      var r = C.calcularMargen({
        costoPieza: f.get('costo'),
        ventaPieza: f.get('venta'),
        piezasMes: f.get('piezas'),
        gastosPct: pctDeGastos(f)
      });
      pintar(r);
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: costo, precio de venta y piezas al mes deben ser mayores a cero.</p>';
        return;
      }
      var CLASE = { verde: 'ok', amarillo: 'alerta', rojo: 'rojo' };
      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--' + CLASE[r.veredicto] + '">';
      if (r.ventaAPerdida) {
        html += '<p class="pp-calc__veredicto-titulo">Así no hay negocio: estás vendiendo a pérdida o en tablas</p>';
        html += '<p class="pp-calc__veredicto-dato">Tu precio de venta no supera lo que te cuesta cada pieza. Antes de mover volumen, consigue mejor precio de mayoreo o sube tu precio de reventa — si no, cada pieza vendida te saca dinero.</p>';
      } else if (r.veredicto === 'verde') {
        html += '<p class="pp-calc__veredicto-titulo">Buen negocio: ganancia neta de ' + fmtDinero(r.gananciaNetaMes) + ' al mes</p>';
        html += '<p class="pp-calc__veredicto-dato">Tu margen neto es de <strong>' + fmtPct(r.margenNetoPct) + '</strong> — arriba del 20% que en reventa de empaque se considera sano. Con ese margen, crecer volumen es crecer ganancia.</p>';
      } else if (r.veredicto === 'amarillo') {
        html += '<p class="pp-calc__veredicto-titulo">Apretado: ganancia neta de ' + fmtDinero(r.gananciaNetaMes) + ' al mes</p>';
        html += '<p class="pp-calc__veredicto-dato">Tu margen neto es de <strong>' + fmtPct(r.margenNetoPct) + '</strong> — sí ganas, pero cualquier gasto imprevisto se lo come. La palanca más rápida: mejor precio de compra por mayoreo.</p>';
      } else {
        html += '<p class="pp-calc__veredicto-titulo">Margen muy delgado: ' + fmtPct(r.margenNetoPct) + ' neto</p>';
        html += '<p class="pp-calc__veredicto-dato">Con menos del 8% neto, el negocio trabaja para sus gastos, no para ti. Revisa tu precio de compra al mayoreo o tu precio de venta antes de invertir más.</p>';
      }
      html += '</div>';
      html += '<dl class="pp-calc__detalle">';
      html += '<div class="pp-calc__detalle-fila"><dt>Margen bruto por pieza</dt><dd>' + fmtPct(r.margenBrutoPct) + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Gastos estimados del mes</dt><dd>' + fmtDinero(r.gastosMes) + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Ganancia neta al mes</dt><dd>' + fmtDinero(r.gananciaNetaMes) + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Inversión mensual en mercancía</dt><dd>' + fmtDinero(r.inversionMes) + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>ROI mensual sobre tu inversión</dt><dd>' + fmtPct(r.roiMensualPct) + '</dd></div>';
      html += '</dl>';
      html += '<p class="pp-calc__nota">En reventa de empaque, un margen neto sano anda arriba del 20% — el volumen hace el resto. El cálculo asume que vendes lo que estimas: si tu inventario rota más lento, tu ROI mensual real baja.</p>';
      out.innerHTML = html;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr();
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
